import { useForm } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { strings } from './Authentication.strings'
import { Button, Divider, ErrorDetail, Input } from '@/ui/components'

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1em;
`

interface FormData {
  code: string
}

interface Props {
  verify: (data: FormData) => void
  resend: () => void
  loading?: boolean
  error?: Error | null
}

export const VerifyForm: React.FC<Props> = ({
  verify,
  resend,
  loading,
  error,
}) => {
  const intl = useIntl()

  const {
    register,
    handleSubmit,
    // formState: { errors }, // TODO: Connect form errors
  } = useForm<FormData>()

  const onSubmission = handleSubmit((data) => {
    verify(data)
  })

  return (
    <>
      <Form onSubmit={onSubmission}>
        <h2>
          <FormattedMessage {...strings.verificationTitle} />
        </h2>
        <Input
          type="password"
          label={intl.formatMessage(strings.verifyLabel)}
          placeholder={intl.formatMessage(strings.verifyPlaceholder)}
          {...register('code')}
          autoComplete="password"
          required
          disabled={loading}
        />
        {error ? <ErrorDetail error={'Error with verification code'} /> : null}
        <Button disabled={loading}>
          <FormattedMessage {...strings.confirmUserBtn} />
        </Button>
        <Divider />
      </Form>
      {/* TODO: Show some kind of message that the code has been sent. */}
      <Button kind="secondary" onClick={resend} type="button">
        <FormattedMessage {...strings.resendBtn} />
      </Button>
    </>
  )
}
